import { selectActivePackage } from './selectActivePackage';
import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';

/**
 *
 * Возвращает НЕ id пакета, а id услуги, к которому принадлежит пакет (топ, премиум и т.д.)
 */
export function selectActivePackageServiceId(state: IAppState): EServiceId | null {
  const activePackage = selectActivePackage(state);

  if (!activePackage) {
    return null;
  }

  return activePackage.serviceId;
}
